module.exports = __webpack_public_path__ + "img/sheep3.4729f73a.jpg";